import type { LegacyEmotionCssObject } from '../../../../../types.tsx';

export const cssFn = (): LegacyEmotionCssObject => ({
	// Display button when the menu item is focused
	'[data-item-elem-after]': {
		opacity: 0,
	},
	'&:hover [data-item-elem-after], &:focus-within [data-item-elem-after]': {
		opacity: 1,
	},
});
